import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import firebase from "firebase";
import {
  auth,
  facebookAuthProvider,
  githubAuthProvider,
  googleAuthProvider,
  twitterAuthProvider,
  signInWithPopup,
} from "firebase/firebase";
import {
  SIGNIN_FACEBOOK_USER,
  SIGNIN_ANON_USER,
  SIGNIN_GITHUB_USER,
  SIGNIN_APPLE_USER,
  SIGNIN_GOOGLE_USER,
  SIGNIN_TWITTER_USER,
  SIGNIN_USER,
  SIGNOUT_USER,
  SIGNUP_USER,
  RECOVER_PASSWORD,
} from "constants/ActionTypes";
import {
  recoverPassword,
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
  userSignUpSuccess,
} from "actions/Auth";
import {
  userAnonSignInSuccess,
  userFacebookSignInSuccess,
  userFacebookSignInFail,
  userGithubSignInSuccess,
  userGoogleSignInSuccess,
  userTwitterSignInSuccess,
  userAppleSignInSuccess,
} from "../actions/Auth";
import swal from "sweetalert";
import { loginWithUsername, accessError } from "../app/accountAccess";
import { connectionSession } from "../app/connectionSession";
import ApiGeneral from "../app/generalApi";

const apiGeneral = new ApiGeneral();

const database = firebase.database();

var appleProvider;

const createUserWithEmailPasswordRequest = async (
  email,
  password,
  nickname,
  city,
  province,
  country,
  phone,
  photo
) =>
  await auth
    .createUserWithEmailAndPassword(email, password)
    .then(async (authUser) => authUser)
    .catch((error) => {
      if (error.includes("already")) {
        swal({
          buttons: {
            confirm: {
              text: "ACEPTAR",
              className: "blue-bg",
              visible: true,
            },
          },
          title: "Atención",
          text: "Ya existe una cuenta con este email, prueba con otro",
          icon: "warning",
        }).then((value) => {
          //console.log(value);
        });
      } else {
        alert(error);
      }
    });

const recoverPasswordRequest = async (email) => {
  //console.log("email", email.payload);

  await auth
    .sendPasswordResetEmail(email.payload)
    .then(() => console.log("sent"))
    .catch((error) => error);
};

/*const signInUserWithEmailPasswordRequest = async (email, password) =>
  await auth
    .signInWithEmailAndPassword(email, password)
    .then((authUser) => authUser)
    .catch((error) => error);*/

const signInUserWithEmailPasswordRequest = async (email, password) => {
  try {
    await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    const identifier = (email || "").trim();
    return identifier.includes("@")
      ? await auth.signInWithEmailAndPassword(identifier, password)
      : await loginWithUsername(identifier, password);
  } catch (error) {
    const text = error.code && error.code.startsWith("auth/")
      ? "Usuario, email o contraseña incorrectos." : accessError(error);
    swal({ title: "No se ha podido acceder", text, icon: "warning" });
    return { message: text };
  }
};

const signOutRequest = async () => {
  await connectionSession.leave();
  return auth.signOut();
};

function* createUserWithEmailPassword({ payload }) {
  const { email, password, nickname, country, province, city, phone, photo } =
    payload;
  try {
    //email, password, nickname, city, province, country, phone
    const signUpUser = yield call(
      createUserWithEmailPasswordRequest,
      email,
      password,
      nickname,
      city,
      province,
      country,
      phone,
      photo
    );
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userSignUpSuccess(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

const signInUserWithGoogleRequest = async () => {
  googleAuthProvider.setCustomParameters({
    prompt: "select_account",
  });

  return await auth
    .signInWithPopup(googleAuthProvider)
    .then((authUser) => authUser)
    .catch((error) => error);
};

const signInUserWithAppleRequest = async () =>
  await auth
    .signInWithPopup(appleProvider)
    .then((authUser) => authUser)
    .catch((error) => error);

const signInUserWithFacebookRequest = async () =>
  await auth
    .signInWithPopup(facebookAuthProvider)
    .then((authUser) => authUser)
    .catch((error) => error);

const signInUserWithAnonRequest = async () =>
  await auth
    .signInAnonymously()
    .then((authUser) => authUser)
    .catch((error) => error);

const signInUserWithGithubRequest = async () =>
  await auth
    .signInWithPopup(githubAuthProvider)
    .then((authUser) => authUser)
    .catch((error) => error);

const signInUserWithTwitterRequest = async () =>
  await auth
    .signInWithPopup(twitterAuthProvider)
    .then((authUser) => authUser)
    .catch((error) => error);

function* signInUserWithGoogle() {
  try {
    const signUpUser = yield call(signInUserWithGoogleRequest);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userGoogleSignInSuccess(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithApple() {
  try {
    appleProvider = new firebase.auth.OAuthProvider("apple.com");
    appleProvider.addScope("email");
    appleProvider.addScope("name");
    const signUpUser = yield call(signInUserWithAppleRequest);

    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userGoogleSignInSuccess(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithFacebook() {
  try {
    const signUpUser = yield call(signInUserWithFacebookRequest);

    //AVISAMOS SI EXISTE UN EMAIL IGUAL

    if (signUpUser.message) {
      if (
        signUpUser.message ===
        "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."
      ) {
        alert(
          "Hemos intentado iniciar sesión con tu email asociado a Facebook, al no existir una, hemos intentado crearla nueva, pero ya existe otra cuenta asociada a este email, prueba a iniciar sesión con otro método."
        );
      }

      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userFacebookSignInSuccess(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithAnon() {
  try {
    /*const signUpUser = yield call(signInUserWithAnonRequest);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userAnonSignInSuccess(signUpUser));
    }*/
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithGithub() {
  try {
    const signUpUser = yield call(signInUserWithGithubRequest);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userGithubSignInSuccess(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithTwitter() {
  try {
    const signUpUser = yield call(signInUserWithTwitterRequest);
    if (signUpUser.message) {
      if (signUpUser.message.length > 100) {
        yield put(showAuthMessage("Your request has been canceled."));
      } else {
        yield put(showAuthMessage(signUpUser.message));
      }
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userTwitterSignInSuccess(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithEmailPassword({ payload }) {
  const { email, password } = payload;
  try {
    const signInUser = yield call(
      signInUserWithEmailPasswordRequest,
      email,
      password
    );
    //console.log(signInUser);

    if (signInUser.message) {
      //console.log(1, signInUser.message);

      yield put(showAuthMessage(signInUser.message));
    } else {
      yield put(userSignInSuccess(signInUser));
    }
  } catch (error) {
    //console.log(error);

    yield put(showAuthMessage(error));
  }
}

function* signOut() {
  try {
    const result = yield call(signOutRequest);
    if (result && result.message) {
      yield put(showAuthMessage(result.message));
    } else {
      localStorage.removeItem("user_id");
      yield put(userSignOutSuccess(null));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* requestPassword() {
  yield takeEvery(RECOVER_PASSWORD, recoverPasswordRequest);
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInWithGoogle() {
  yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export function* signInWithAnon() {
  yield takeEvery(SIGNIN_ANON_USER, signInUserWithAnon);
}

export function* signInWithApple() {
  yield takeEvery(SIGNIN_APPLE_USER, signInUserWithApple);
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
}

export function* signInWithTwitter() {
  yield takeEvery(SIGNIN_TWITTER_USER, signInUserWithTwitter);
}

export function* signInWithGithub() {
  yield takeEvery(SIGNIN_GITHUB_USER, signInUserWithGithub);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
  yield all([
    fork(signInWithApple),
    fork(requestPassword),
    fork(signInUser),
    fork(createUserAccount),
    fork(signInWithGoogle),
    fork(signInUserWithAnon),
    fork(signInWithFacebook),
    fork(signInWithTwitter),
    fork(signInWithGithub),
    fork(signOutUser),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Auth.js